import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { ThemeProvider } from 'styled-components'

import { useRootStore } from '~/store/RootStore'
import { routeTree } from '~/routeTree.gen' // This is an auto generated file
import { IWholesalerConfig, Theme } from './wholesalers/IWholesalerConfig'
import ErrorBoundary from './utils/ErrorBoundary'

import Loading from './components/loading'
import { ErrorBoundaryWrapper, NotFound } from './components/elements'

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: false,
  scrollRestoration: true,
  context: {
    store: undefined!,
  },
  defaultPendingComponent: () => <Loading />,
  defaultNotFoundComponent: () => <NotFound />,
  defaultErrorComponent: ({ error }) => {
    return (
      <ErrorBoundaryWrapper>
        <h2>Error</h2>
        <p style={{ whiteSpace: 'pre-wrap' }}>{error.message}</p>
      </ErrorBoundaryWrapper>
    )
  },
})

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface HistoryState {
    data?: { [key: string]: any }
    triggeredBy?: string
    path?: string
  }
}

const config = WHOLESALERCONFIG as IWholesalerConfig
const theme = config && config.theme ? config.theme : ({} as Theme)

function App() {
  const store = useRootStore()
  return <RouterProvider router={router} context={{ store }} />
}

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
)
